import {View, Text} from 'react-native';
import moment from 'moment';

export default function formatAssetName(asset) {
  let name = '';
  if(asset.year) {
    name += asset?.year;
  }
  if(asset.make) {
    name += ` ${asset?.make}`;
  }
  if(asset.model) {
    name += ` ${asset?.model}`;
  }
  if(asset.type) {
    name += ` ${asset?.type}`
  }

  return name;
}

export function formatAssetNameForSelect(asset) {
  return `${asset.vin} ${asset.stockNumber} | ${asset.seller?.name } | ${asset.name}`;
}

export function formatAddress(resource, type) {
  let address = '';
  let line2 = [];
  if(resource.street) {
    address += resource.street;
  }
  if(type === 'Seller') {
    address += `\n`;
  }else if(resource.city || resource.state || resource.postalCode?.formatted) {
    address += ', ';
  }
  if(resource.city) {
    line2 = [...line2, resource.city];
  }
  if(resource.state) {
    line2 = [...line2, resource.state];
  }
  if(resource.postalCode?.formatted) {
    line2 = [...line2, resource.postalCode?.formatted];
  }
  address += line2.join(', ')
  return address;
}

export function formatBuyerInfo(asset) {
  return (
    <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
      <View>
        <Text>
          {asset?.soldOn && (
            <b>
              {`Asset Sold On: ${moment(asset?.soldOn).format('MM-DD-YYYY')}`}
            </b>
          )}
          <br />
          {`Miles: ${asset.miles || 'Not Listed'}`}<br/>
        </Text>
      </View>
      <View>
        <Text>
          <b>Buyer Info:</b><br />
          {asset.buyer ? (
            <Text>
              {asset.buyer?.name}<br />
              {formatAddress(asset.buyer)}<br />
            </Text>
          ) : (
            <Text style={{fontWeight: 800}}>NO BUYER ENTERED</Text>
          )}
          <br />
        </Text>
      </View>
    </View>
  )
}
